import React from "react";
import { Output } from "../Text";
import { Modal } from "@vwfs-bronson/bronson-react";
import * as H from 'history';
import { RouteComponentProps } from "react-router-dom";
import Route from "./Navigation";

export class NavigationBlockedModal extends React.Component<RouteComponentProps, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      visible: false,
    };
  }

  registerBlockingNavigation = (history: H.History) => {
    const availableBackButtonPages = [ Route.Calculation, Route.Prefill, Route.BoniLanding ];
    let currentPathname = "";
    let currentSearch = "";

    history.listen((newLocation, action) => {
      if (action === "PUSH") {
        if (
          newLocation.pathname !== currentPathname ||
          newLocation.search !== currentSearch
        ) {
          // GFTDE-900 workaround: Clear the viewChange variable on navigate
          // Analytics.clearViewChange();

          // Save new location
          currentPathname = newLocation.pathname;
          currentSearch = newLocation.search;

          // Clone location object and push it to history
          history.push({
            pathname: newLocation.pathname,
            search: newLocation.search,
            state: newLocation.state,
          });
        }
      } else {
        if (availableBackButtonPages.includes(history.location.pathname as Route)) {
          history.goBack();
          return;
        } else if (history.location.pathname === Route.Error) {
          // Skip blocking on error page
          return;
        }
  
        // Send user back if they try to navigate back
        history.go(1);
        this.show();
      }
    });
  };

  componentDidMount() {
    this.registerBlockingNavigation(this.props.history);
  }

  show() {
    this.setState({ visible: true });
  }

  hide() {
    this.setState({ visible: false });
  }

  render() {
    const visible = this.state.visible && this.props.history.location.pathname !== Route.Error;

    return (
      <Modal
        title={Output.resolve("pages.navigationBlockedModal.title")}
        onClose={() => {
          this.hide();
        }}
        buttonConfirmText={Output.resolve("pages.navigationBlockedModal.close")}
        onConfirm={()=>{
          this.hide();
        }}
        shown={visible}
      >
        {Output.resolveAsMarkdown("pages.navigationBlockedModal.text")}
      </Modal>
    );
  }
}
